export const environment = {
	production: true,
	siteUrl: 'https://app.tada.market/',
	apiUrl: 'https://api.tada.market/api/v1',
	wsUrl: 'https://api.tada.market/api/v1/notifications',
	authUrl: 'https://auth.tada.market',
	swaggerUrl: 'https://api.tada.market/api/v1/v3/api-docs',
}
